import { resourceExplorerGlobalPossibleFiltersSelector } from "./resourceExplorerGlobalPossibleFiltersSelector";
import { RootState } from "../../../../../store";
import { ResourceExplorerPossibleFilter } from "../../../../../../services/cloudchipr.api";

export const possibleFilterDimensionsSelector = (
  state: RootState,
): ResourceExplorerPossibleFilter | undefined => {
  const filters = resourceExplorerGlobalPossibleFiltersSelector(state);

  return filters?.find((filter) => filter.key === "dimension_id");
};
